/**
 * Proj-free CEA area calculation
 *
 * Maths provided by the good folks hosting the EASE-Grid 2.0 whitepaper:
 * - https://www.mdpi.com/2220-9964/1/1/32
 *
 */

// These are the constants necessary to compute
//  the globe as a cylinder.
const a = 6378137;
// Used only for inverse projection
// const f = 1 / 298.257223563;
// const b = 6356752.314;
const e = 0.0818191908426;
const theta1 = 30;

function radians(degrees) {
  return degrees * (Math.PI / 180.0);
}

function sin(v) {
  return Math.sin(radians(v));
}

function cos(v) {
  return Math.cos(radians(v));
}

// Convert a CRS84 point to CEA.
function degreeToCEA(point) {
  const [lon, lat] = point;
  const k0 = cos(theta1) / Math.sqrt(1 - e * e * sin(theta1) * sin(theta1));

  const sinTheta = sin(lat);
  const qTheta =
    (1 - e * e) *
    (sinTheta / (1 - e * e * sinTheta * sinTheta) -
      (1 / (2 * e)) * Math.log((1 - e * sinTheta) / (1 + e * sinTheta)));

  const x = a * k0 * radians(lon);
  const y = (a * qTheta) / (2 * k0);

  return [x, y];
}

// "Shoelace" area calculation.
function area(coordinates) {
  let tmpArea = 0.0;

  const count = coordinates.length;
  let [x1, y1] = coordinates[count - 1];

  for (let idx = 0; idx < count - 1; idx++) {
    const [x2, y2] = coordinates[idx + 1];
    tmpArea += y1 * x2 - x1 * y2;
    x1 = x2;
    y1 = y2;
  }

  // area can be negative if the coordinates are
  //  out of order.
  const div = tmpArea < 0 ? -2.0 : 2.0;
  return tmpArea / div;
}

// Converts the coordinate list to CEA
//  and then gets the area.
function ceaArea(coordinates) {
  return area(coordinates.map(pt => degreeToCEA(pt)));
}

export function getArea(geojson) {
  let area = 0.0;
  let polygons = [];

  if (geojson.type === 'GeometryCollection') {
    // summarize the area for the collection
    geojson.geometries.forEach(geometry => {
      area += getArea(geometry);
    });
  } else if (geojson.type === 'Polygon') {
    polygons = [geojson.coordinates];
  } else if (geojson.type === 'MultiPolygon') {
    polygons = geojson.coordinates;
  } else {
    // nothing else has area.
    return 0;
  }

  polygons.forEach(polygon => {
    area += ceaArea(polygon[0]);
    // using for-loop in here to prevent needing to
    //  slice the array
    for (let i = 1, ii = polygon.length; i < ii; i++) {
      area -= ceaArea(polygon[i]);
    }
  });

  return area;
}
